module.exports = __webpack_public_path__ + "static/media/rounded-screen.6c15d828.svg";